import { render, staticRenderFns } from "./resHelp.vue?vue&type=template&id=d0a9d7be&scoped=true&"
import script from "./resHelp.vue?vue&type=script&lang=js&"
export * from "./resHelp.vue?vue&type=script&lang=js&"
import style0 from "./resHelp.vue?vue&type=style&index=0&id=d0a9d7be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0a9d7be",
  null
  
)

export default component.exports